/* FISHEON — interactions Shopify */
(function () {
  const grid = document.querySelector('[data-product-grid]');
  const searchInput = document.querySelector('[data-search-input]');
  const stockSelect = document.querySelector('[data-stock-select]');
  const sortSelect = document.querySelector('[data-sort-select]');
  const emptyState = document.querySelector('[data-empty-state]');
  const chips = Array.from(document.querySelectorAll('[data-category-chip]'));

  let currentCategory = 'all';

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function renderProducts() {
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
    const query = normalize(searchInput && searchInput.value);
    const stock = stockSelect ? stockSelect.value : 'all';

    let visibleCards = [];

    cards.forEach(card => {
      const searchable = normalize(card.dataset.search);
      const cardStock = card.dataset.stock || 'all';
      const matchesCategory = currentCategory === 'all' || searchable.includes(normalize(currentCategory));
      const matchesStock = stock === 'all' || cardStock === stock;
      const matchesSearch = !query || searchable.includes(query);
      const visible = matchesCategory && matchesStock && matchesSearch;
      card.dataset.hidden = visible ? 'false' : 'true';
      if (visible) visibleCards.push(card);
    });

    if (sortSelect) {
      const sort = sortSelect.value;
      visibleCards.sort((a, b) => {
        if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort === 'name') return normalize(a.dataset.title).localeCompare(normalize(b.dataset.title));
        return Number(a.dataset.index) - Number(b.dataset.index);
      });
      visibleCards.forEach(card => grid.appendChild(card));
    }

    if (emptyState) emptyState.style.display = visibleCards.length ? 'none' : 'block';
  }

  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      chips.forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
      currentCategory = chip.dataset.categoryChip || 'all';
      renderProducts();
    });
  });

  if (searchInput) searchInput.addEventListener('input', renderProducts);
  if (stockSelect) stockSelect.addEventListener('change', renderProducts);
  if (sortSelect) sortSelect.addEventListener('change', renderProducts);
  renderProducts();
})();

/* FISHEON — panier : boutons + / - et suppression */
(function () {
  const forms = Array.from(document.querySelectorAll('[data-cart-quantity-form]'));
  if (!forms.length) return;

  forms.forEach((form) => {
    const input = form.querySelector('[data-cart-quantity-input]');
    const minus = form.querySelector('[data-cart-quantity-minus]');
    const plus = form.querySelector('[data-cart-quantity-plus]');

    if (!input) return;

    function submitWithQuantity(quantity) {
      const safeQuantity = Math.max(0, Number(quantity) || 0);
      input.value = safeQuantity;
      form.submit();
    }

    if (minus) {
      minus.addEventListener('click', () => {
        submitWithQuantity(Number(input.value) - 1);
      });
    }

    if (plus) {
      plus.addEventListener('click', () => {
        submitWithQuantity(Number(input.value) + 1);
      });
    }

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        submitWithQuantity(input.value);
      }
    });
  });
})();


/* FISHEON — fiche produit : galerie photos cliquable */
(function () {
  const galleries = Array.from(document.querySelectorAll('[data-product-gallery]'));
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-product-main-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));

    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.dataset.fullSrc;
        const alt = thumb.dataset.alt || mainImage.alt || '';

        if (!fullSrc) return;

        mainImage.src = fullSrc;
        mainImage.alt = alt;
        mainImage.removeAttribute('srcset');

        thumbs.forEach((item) => item.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });
})();

/* FISHEON — popup offre première commande */
(function () {
  const popup = document.querySelector('[data-welcome-popup]');
  if (!popup) return;

  const storageKey = 'fisheon-welcome-mini-popup-closed-v2';
  const closeButtons = Array.from(document.querySelectorAll('[data-welcome-popup-close]'));

  function hasSeenPopup() {
    try {
      return window.localStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function rememberClosed() {
    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (error) {}
  }

  function openPopup() {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
  }

  function closePopup() {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    rememberClosed();
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) closePopup();
  });

  if (!hasSeenPopup()) {
    window.setTimeout(openPopup, 900);
  }
})();


/* FISHEON — panier : bouton Commander robuste */
(function () {
  const checkoutButtons = Array.from(document.querySelectorAll('[data-checkout-button]'));
  if (!checkoutButtons.length) return;

  checkoutButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      window.location.href = '/checkout';
    });
  });
})();


/* FISHEON v15 — lien Livraison footer sans page Shopify obligatoire */
(function () {
  const modal = document.querySelector('[data-shipping-modal]');
  const links = Array.from(document.querySelectorAll('[data-shipping-link]'));
  if (!modal || !links.length) return;

  const closeButtons = Array.from(document.querySelectorAll('[data-shipping-close]'));

  function openModal(event) {
    if (event) event.preventDefault();
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  links.forEach((link) => link.addEventListener('click', openModal));
  closeButtons.forEach((button) => button.addEventListener('click', closeModal));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });
})();
